/*
 * @Author: Sergiy Samborskiy
 * @Date: 2017-11-15 17:18:56
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2017-11-15 17:29:35
 */

import * as React from "react";

import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import Visibility from 'material-ui/svg-icons/action/visibility';

export function PortItem(props) {
    const { child, isMainPort, toggleMainPort, removePort, showPort } = props;

    if (!child) {
       return ''
    }
    
    return (
        <div style={{ width: '100%', margin: 0 }} >
            <div style={{ width: '100%', fontSize: '12px', display: 'flex', alignItems: 'center' }}>
                <Checkbox
                    checked={isMainPort}
                    style={{ width: '80%', display: 'block' }}
                    label={child.name}
                    onCheck={(e, value) => {
                        toggleMainPort(child, value)
                    }}
                />
                <IconButton onClick={() => {
                    showPort(child);
                }}>
                    <Visibility />
                </IconButton>
                <IconButton onClick={() => {
                    removePort(child);
                }}>
                    <NavigationClose />
                </IconButton>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/Ports/PortItem.jsx